// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__15yX-","head":"Table_head__sO0y9","col":"Table_col__1kJQF"};